'use client';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { safeHtmlListParserOptions } from '@/utils/safeHtmlParserOptions';
import parse from 'html-react-parser';
import { BsTextParagraph } from 'react-icons/bs';
import { TbCancel } from 'react-icons/tb';

const PoliciesAccordion = ({
  policies,
}: {
  policies: any[];
}) => {
  const defaultPolicies = [
    {
      title: 'General Terms',
      description: [
        'All the guests are requested to follow the rules and regulations of the organizing team.',
        'Consumption of alcohol or any kind of drugs is strictly prohibited before and during the programme, you may be barred if found under such possession unless stated by the organiser.',
        'In case the event is cancelled or delayed from organizer’s end, Greet is not responsible for any kind of refund or loss caused.'
      ],
    },
    {
      title: 'Cancellation/Refund Policy',
      description:
        "<ul><li>Tickets once booked aren't cancellable.</li><li> In case the amount has been deducted and the desired seat isn’t allocated, a full refund will be credited to the original payment mode within 5–7 working days.</li></ul>",
    },
  ];
  const policiesData = policies?.length !== 0 ? policies : defaultPolicies;

  return (
    <div className='my-6'>
      <Accordion type='single' collapsible defaultValue='item-0'>
        {policiesData?.map((obj: any, i: number) => {
          return (
            <AccordionItem
              value={`item-${i}`}
              className='mt-2 overflow-hidden border-none'
              key={i}
            >
              <AccordionTrigger className='border rounded-xl px-3 hover:bg-gray-100 hover:no-underline'>
                <div className='flex items-center gap-2'>
                  {obj?.title == 'General Terms' ? (
                    <BsTextParagraph size={20} />
                  ) : obj?.title == 'Cancellation/Refund Policy' ? (
                    <TbCancel size={20} />
                  ) : (
                    <></>
                  )}
                  <p className='text-base! font-bold tracking-wide sm:text-base sm:font-semibold'>
                    {obj?.title}
                  </p>
                </div>
              </AccordionTrigger>
              <AccordionContent className='px-2 py-2'>
                <ul className='list-item space-y-3 !list-disc'>
                  {Array.isArray(obj?.description) ? (
                    obj?.description?.map((item: any, index: number) => {
                      return (
                        <li key={index} className='text-zinc-600 text-xs font-semibold sm:text-sm sm:font-medium'>
                          {item}
                        </li>
                      );
                    })
                  ) : (
                    <li className='flex flex-col gap-2 text-xs font-semibold text-zinc-600 sm:text-sm sm:font-medium [&>ul]:list-disc [&>ul]:pl-5 [&>ol]:list-decimal [&>ol]:pl-5'>
                      {obj?.description && parse(obj.description, safeHtmlListParserOptions)}
                    </li>
                  )}
                </ul>
              </AccordionContent>
            </AccordionItem>
          );
        })}
      </Accordion>
    </div>
  );
}

export default PoliciesAccordion;